import { render, staticRenderFns } from "./PromotionView.vue?vue&type=template&id=47252554"
import script from "./PromotionView.vue?vue&type=script&lang=ts"
export * from "./PromotionView.vue?vue&type=script&lang=ts"
import style0 from "./PromotionView.vue?vue&type=style&index=0&id=47252554&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports